import { HTTP_NO_CONTENT } from './http.constants';

export const APPLICATION_BODY_ID = 'spo-app-body';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY - HH:mm';

export const BFF_HOST = {
  development: 'http://localhost:4000',
  acceptance: '',
  production: ''
};

export const AUTH_METHODS = {
  MPROFIEL: 'mprofiel',
  APROFIEL: 'aprofiel'
};

export const EXPIRATION_DELAY = 10 * 60 * 1000; // 10 MINUTES

export const MAX_LOGIN_TIME = 24 * 60 * 60 * 1000; // 24 HOURS

export const FORM_COMPOSER_HOST = {
  development: 'https://formcomposer-a.antwerpen.be/overzicht?tenant=20885e4e-abb6-4e9b-ac4e-60f931281c06',
  acceptance: 'https://formcomposer-a.antwerpen.be/overzicht?tenant=20885e4e-abb6-4e9b-ac4e-60f931281c06',
  production: 'https://formcomposer.antwerpen.be/overzicht?tenant=8690c3bd-274e-4531-a0c0-420de6825e4f'
};

export const ALL_SELECT_OPTION = { value: 'all', label: 'Alle' };

export const SPO_EMAIL_NOREPLY = 'noreply-SamenwerkingsplatformOnderwijs@antwerpen.be';

export const MAX_SIZE_MEDIA = 10000000;
export const MAX_SIZE_MEDIA_TEXT = '10MB';
// export const IMAGE_FILE_FORMATS = ['jpg', 'jpeg', 'bmp', 'gif', 'png'];
// export const VIDEO_FILE_FORMATS = ['avi', 'wmv', 'mov', 'mkv', '3gp', 'mp4'];

export const MAILTO_BODY_LINEBREAK = '%0D%0A';

export const PREFERENCE_UPSERT_SUCCESS_HTTP_STATUS = HTTP_NO_CONTENT;

export const SIDEBAR_TABS = {
  ACTIVITY: 'activity',
  COMMENTS: 'comments'
};

export const ATTACHMENT_TYPES = {
  REQUEST: 'request',
  CLARIFICATION: 'clarification',
  CASETAFEL: 'casetafel',
  CASETAFEL_REPORT: 'casetafel_report',
  MEASURE_MOMENT: 'measure_moment',
  PROCEDURE: 'procedure',
  PROCEDURE_PART: 'procedure_part',
  CONTACT_MOMENT: 'contact_moment',
  OTHER: 'andere'
};

export const DOSSIER_TYPES = {
  PROGRAM: 'traject',
  FINANCED_PROGRAM: 'traject_met_toelage',
  ACTION: 'actie',
  NONE: 'none'
};

export const DOSSIER_TYPE_OPTIONS = [
  { value: DOSSIER_TYPES.ACTION, label: 'Actie' },
  { value: DOSSIER_TYPES.NONE, label: 'None' },
  { value: DOSSIER_TYPES.PROGRAM, label: 'Traject' },
  { value: DOSSIER_TYPES.FINANCED_PROGRAM, label: 'Traject met toelage' }
];

export const DOSSIER_STATUSES = {
  NEW_TRAJECT: {
    name: 'Aanvraag',
    id: 0
  },
  CLARIFIERS_ADDED: {
    name: 'Vraagverhelderaars toegewezen',
    id: 1
  },
  CLARIFICATION_DATE_ADDED: {
    name: 'Vraagverheldering in behandeling',
    id: 2
  },
  READY_FOR_CASETAFEL: {
    name: 'Klaar voor casetafel',
    id: 3
  },
  CASETAFEL_SCHEDULED: {
    name: 'Casetafel geagendeerd',
    id: 4
  },
  CASETAFEL_FEEDBACK: {
    name: 'Terugkoppeling casetafel',
    id: 5
  },
  PROCEDURE_STARTED: {
    name: 'Opvolging gestart',
    id: 6
  },
  NEW_FINANCED_TRAJECT: {
    name: 'Aanvraag toelage gestart',
    id: 7
  },
  READY_FOR_COMMISSION: {
    name: 'Klaar voor commissie',
    id: 8
  },
  COMMISSION_SCHEDULED: {
    name: 'Commissie geagendeerd',
    id: 9
  },
  COMMISSION_FEEDBACK: {
    name: 'Terugkoppeling commissie',
    id: 10
  },
  PROCEDURE_FINANCED_STARTED: {
    name: 'Opvolging gestart',
    id: 11
  },
  NEW_ACTION: {
    name: 'Gestart',
    id: 12
  },
  ACTION_ONGOING: {
    name: 'Lopende',
    id: 13
  },
  ACTION_IN_SUCCESSION: {
    name: 'In opvolging',
    id: 14
  },
  ON_HOLD: {
    name: 'On hold',
    id: 15
  },
  CLOSED: {
    name: 'Afgesloten',
    id: 16
  }
};

export const DOSSIER_ACTIE_STATUSES = {
  NEW_ACTION: {
    name: 'Gestart',
    id: 12
  },
  ACTION_ONGOING: {
    name: 'Lopende',
    id: 13
  },
  ACTION_IN_SUCCESSION: {
    name: 'In opvolging',
    id: 14
  },
  ON_HOLD: {
    name: 'On hold',
    id: 15
  },
  CLOSED: {
    name: 'Afgesloten',
    id: 16
  }
};

export const FORM_TYPE_PROP = 'spoFormType';

export const FORM_TYPES = {
  OFFERING: 'offering',
  CASETAFEL: 'casetafel'
};

export const FIELD_TYPES = {
  TEXT: 'text',
  TEXT_AREA: 'text_area',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  SWITCH: 'switch'
};

export const TOAST_TYPES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING'
};

export const PRIVACY_POLICY_LINK =
  'https://www.onderwijsnetwerkantwerpen.be/sites/default/files/2022-07/SPO_privacyverklaring.pdf';
export const TERMS_AND_CONFIDENTIALITY_LINK =
  'https://www.onderwijsnetwerkantwerpen.be/sites/default/files/2022-07/SPO_vertrouwelijkheidsverklaring.pdf';
